import {useEffect, useState} from "react";
import {supabase} from "../supabaseClient";
export function useTopCredits(limit = 3)
{
   const [images,setImages] = useState([]);
   useEffect(() =>{
       async function fetchRecent(){
           const { data, error } = await supabase
               .from('credits')
               .select('*')
               .neq("imageURL","")
               .order('Date', { ascending: false })
               .limit(limit);

           if(error){
               console.log(error);
           }else {
               setImages(data);
           }
       }
       fetchRecent();
   },[limit]);
   return images;
}